export interface IBlogFilterState {
    searchText: string;
    category: string;
    publishDate: string;
    page: number; // 0-based (ReactPaginate convention); 1-based in the URL
}

export const defaultFilterState: IBlogFilterState = {
    searchText: '',
    category: '',
    publishDate: '',
    page: 0,
};

export function filterStateFromUrl(search: string): IBlogFilterState {
    const qs = new URLSearchParams(search);
    const pageParam = parseInt(qs.get('page') ?? '1', 10);
    return {
        searchText: qs.get('search') ?? '',
        category: qs.get('categories') ?? '',
        publishDate: qs.get('date') ?? '',
        page: Number.isFinite(pageParam) && pageParam > 1 ? pageParam - 1 : 0,
    };
}

export function filterStateToUrl(state: IBlogFilterState): string {
    const qs = new URLSearchParams();
    if (state.searchText) qs.set('search', state.searchText);
    if (state.category) qs.set('categories', state.category);
    if (state.publishDate) qs.set('date', state.publishDate);
    if (state.page > 0) qs.set('page', String(state.page + 1));
    const query = qs.toString();
    return window.location.pathname + (query ? `?${query}` : '');
}
